// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"CaptureVisa_style_b-icon-warning__hiadn","wrapper":"CaptureVisa_style_wrapper__1b7G8","rotate":"CaptureVisa_style_rotate__FaCvR"};